import {Component, EventEmitter, Input, Output} from "@angular/core";
import {fromFileListToListOfFiles} from "@app/modules/browse/helpers";

@Component({
  selector: "app-drag-and-drop-file",
  templateUrl: "./drag-and-drop-file.component.html",
  styleUrls: ["./drag-and-drop-file.component.scss"],
})
export class DragAndDropFileComponent {
  @Input() fileName: string = null;
  @Input() invalidFiles: boolean;
  @Output() filesChange: EventEmitter<File> = new EventEmitter<File>();
  @Output() clearFiles: EventEmitter<void> = new EventEmitter<void>();

  fileInputClick(input: HTMLInputElement): void {
    input.click();
  }

  selectedFileChange(event: Event): void {
    const files = fromFileListToListOfFiles((event.target as HTMLInputElement).files);
    this.uploadedFileChange(files);
  }

  filesDrop(files: File[]): void {
    this.uploadedFileChange(files);
  }

  clearInput(): void {
    this.clearFiles.emit();
  }

  private uploadedFileChange(files: File[]): void {
    if (files?.length) {
      this.filesChange.emit(files[0]);
    }
  }
}
